<template>
    <div class='civilian'>
        <div class='civilian_left'>
            <dialogCenter :productType='1' :dialogData ='dialogData'></dialogCenter>
        </div>
        <div class='civilian_right'>
            <dialogLeft :dialogData='dialogData' :productType='1'></dialogLeft>
        </div>
    </div>
</template>
<script>
import dialogCenter from './dialog_center'
import dialogLeft from './dialog_left'
export default {
    props:{
        dialogData:{
            type:Object,
            default:()=>{}
        },
    },

    data(){
        return{
            dialog_data:{},
         
        }
    },
    components:{
        dialogCenter,
        dialogLeft
    },
    watch:{
        dialogData:{
            handler:function(newVal,oldVal){
                // this.pageInit()
            },
            deep:true
        }
        
    },
    mounted () {

    },
    computed: {

    },
    methods:{
        pageInit(){
        //     this.dialog_data ={};
        //     this.dialog_data = this.$deepClone(this.dialogData);
        //     this.alarm_detail = this.$deepClone(this.dialog_data.alarmDetailData);
        //     this.mes_data = this.$deepClone(this.dialog_data.mesData);
        //     this.device_data = this.$deepClone(this.dialog_data.deviceData);
        //   this.position_item = this.$deepClone(this.dialog_data.alarmDetailData.position);

        },
    }

}
</script>
<style lang="less" scoped>
.civilian{
    width: 100%;

    display: flex;


    .civilian_left{
        position: absolute;
         width: 70%;
        flex: 1;
        // background: yellow;
        margin-top: 40px;
        padding-left: 70px;
    }
    .civilian_right{
        position: absolute;
        width: 40%;
        height: 85%;
        right: 0%;
        top: 14%;
        // background: red;
        // margin-top: 40px;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/dialog/dialog_civilian.vue